module.exports = __webpack_public_path__ + "img/6.c50dd8c0.png";